import { render, staticRenderFns } from "./AwardFilterLink.vue?vue&type=template&id=681b737a&scoped=true"
import script from "./AwardFilterLink.vue?vue&type=script&lang=js"
export * from "./AwardFilterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b737a",
  null
  
)

export default component.exports